/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';
import type { GetAppointmentBaseResponse } from './GetAppointmentBaseResponse';
import {
    GetAppointmentBaseResponseFromJSON,
    GetAppointmentBaseResponseFromJSONTyped,
    GetAppointmentBaseResponseToJSON,
    GetAppointmentBaseResponseToJSONTyped,
} from './GetAppointmentBaseResponse';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { GetClassBaseResponse } from './GetClassBaseResponse';
import {
    GetClassBaseResponseFromJSON,
    GetClassBaseResponseFromJSONTyped,
    GetClassBaseResponseToJSON,
    GetClassBaseResponseToJSONTyped,
} from './GetClassBaseResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetAttendanceLogResponse
 */
export interface GetAttendanceLogResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAttendanceLogResponse
     */
    id: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetAttendanceLogResponse
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAttendanceLogResponse
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof GetAttendanceLogResponse
     */
    appointmentId: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAttendanceLogResponse
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetAttendanceLogResponse
     */
    timeIn: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttendanceLogResponse
     */
    timeOut: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAttendanceLogResponse
     */
    remarks: string | null;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof GetAttendanceLogResponse
     */
    status: AttendanceStatus;
    /**
     * 
     * @type {Date}
     * @memberof GetAttendanceLogResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {GetAppointmentBaseResponse}
     * @memberof GetAttendanceLogResponse
     */
    appointment: GetAppointmentBaseResponse | null;
    /**
     * 
     * @type {GetClassBaseResponse}
     * @memberof GetAttendanceLogResponse
     */
    _class: GetClassBaseResponse | null;
}



/**
 * Check if a given object implements the GetAttendanceLogResponse interface.
 */
export function instanceOfGetAttendanceLogResponse(value: object): value is GetAttendanceLogResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timeIn' in value) || value['timeIn'] === undefined) return false;
    if (!('timeOut' in value) || value['timeOut'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('appointment' in value) || value['appointment'] === undefined) return false;
    if (!('_class' in value) || value['_class'] === undefined) return false;
    return true;
}

export function GetAttendanceLogResponseFromJSON(json: any): GetAttendanceLogResponse {
    return GetAttendanceLogResponseFromJSONTyped(json, false);
}

export function GetAttendanceLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttendanceLogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'appointmentId': AppointmentRequestVariantIdFromJSON(json['appointmentId']),
        'date': (new Date(json['date'])),
        'timeIn': json['timeIn'],
        'timeOut': json['timeOut'],
        'remarks': json['remarks'],
        'status': AttendanceStatusFromJSON(json['status']),
        'createdAt': (new Date(json['createdAt'])),
        'appointment': GetAppointmentBaseResponseFromJSON(json['appointment']),
        '_class': GetClassBaseResponseFromJSON(json['class']),
    };
}

export function GetAttendanceLogResponseToJSON(json: any): GetAttendanceLogResponse {
    return GetAttendanceLogResponseToJSONTyped(json, false);
}

export function GetAttendanceLogResponseToJSONTyped(value?: GetAttendanceLogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'appointmentId': AppointmentRequestVariantIdToJSON(value['appointmentId']),
        'date': value['date'].toISOString().substring(0,10),
        'timeIn': value['timeIn'],
        'timeOut': value['timeOut'],
        'remarks': value['remarks'],
        'status': AttendanceStatusToJSON(value['status']),
        'createdAt': value['createdAt'].toISOString(),
        'appointment': GetAppointmentBaseResponseToJSON(value['appointment']),
        'class': GetClassBaseResponseToJSON(value['_class']),
    };
}

